export function getNameFromSlug(slug) {
  const parts = slug.split('/');

  if (parts.length > 0) {
    return parts[parts.length - 1];
  }

  return slug;
}
